import React from "react";
import "../component/patientTable.css";

const PatientTable = ({
  page,
  patients,
  onEditPatientClicked,
  onDeletePatientClicked,
  onPatientClicked,
}) => {
  const editPatient = (patient) => {
    onEditPatientClicked(patient);
  };

  const deletePatient = (patient) => {
    onDeletePatientClicked(patient);
  };

  const onPatientClick = (patientId) => {
    onPatientClicked(patientId);
  };

  return (
    <div className="patient-table-container">
      <table className="patient-table">
        <thead>
          <tr>
            <th width="50px">No</th>
            <th>Nomor Pasien</th>
            <th>Nama Pasien</th>
            <th>Tanggal lahir</th>
            <th>Jenis Kelamin</th>
            <th>Alamat</th>
            <th>No Handphone</th>
            <th>Poin Klinik</th>
            <th>Poin Apotek</th>
            <th width="150px">Actions</th>
          </tr>
        </thead>
        <tbody>
          {patients.length > 0 ? (
            patients.map((patient, index) => (
              <tr
                key={index}
                onClick={() => {
                  onPatientClick(patient.patient_id);
                }}
              >
                <td>{(page - 1) * 10 + index + 1}</td>
                <td>{patient.patient_number}</td>
                <td>{patient.patient_name}</td>
                <td>{patient.patient_birthday}</td>
                <td>{patient.patient_gender}</td>
                <td>{patient.patient_address}</td>
                <td>{patient.patient_phone_number}</td>
                <td>{patient.patient_clinic_point}</td>
                <td>{patient.patient_pharmacy_point}</td>
                <td>
                  <button
                    className="edit-doctor-specialist-button"
                    onClick={(evt) => {
                      evt.stopPropagation()
                      editPatient(patient);
                    }}
                  >
                    Edit
                  </button>
                  <button
                    className="delete-doctor-specialist-button"
                    onClick={(evt) => {
                      evt.stopPropagation()
                      deletePatient(patient);
                    }}
                  >
                    Hapus
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8" style={{ textAlign: "center" }}>
                Data tidak tersedia
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default PatientTable;
